import { useState } from "react";
import { Grid } from "semantic-ui-react";
import { images } from "../../assets/images";
import { TitleBar } from "../../components";
import BOMCard from "../../components/bomCard/BOMCard";
import { BOMViewType } from "../../config/enums/BOMViewType.enum";
import "./billOfMaterial.scss";
import IngredientList from "./ingredientList/IngredientList";

const BillOfMaterial = () => {
  const [activeView, setActiveView] = useState<BOMViewType>(BOMViewType.INGREDIENT);

  const handleCardClick = (view: BOMViewType) => {
    setActiveView(view);
  };

  return (
    <>
      <TitleBar titleName={"Bill Of Material"} />
      <Grid className="bill-of-material-container">
        <Grid.Column computer={16}>
          <div className="bom-cards-container">
            <BOMCard
              icon={images.ingredients_icon}
              title="Add Ingredients"
              isActive={activeView === BOMViewType.INGREDIENT}
              onClick={() => handleCardClick(BOMViewType.INGREDIENT)}
            />
          </div>

          <div className="bom-content">
            {(() => {
              switch (activeView) {
                case BOMViewType.INGREDIENT:
                  return <IngredientList />;
                default:
                  return null;
              }
            })()}
          </div>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default BillOfMaterial;
